import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { ContentWrapper } from '../components/content_wrapper/content_wrapper';
import { List } from '../components/list/list';
import { ScrollToTop } from '../components/scroll_to_top/scroll_to_top';
import { SEO } from '../components/seo/seo';
import { getList } from '../redux/list';
import base from '../styles/base.less';
import styles from './list_page.less';

const ExpertPage = () => {
  const list = useSelector(getList);

  if (!list) {
    return null;
  }

  return (
    <ScrollToTop>
      <section>
        <SEO title={list.meta_title || list.title} description={list.meta_description} />

        <header className={styles.header}>
          <div
            className={classNames(
              base.contentWrapper,
              base.contentWrapper__mobileNoPadding,
              styles.headerContent
            )}
          >
            <div className={styles.headingText}>
              <h1 className={styles.headingHeader}>{list.title}</h1>
              {list.subtitle && <p className={styles.headingSubhead}>{list.subtitle}</p>}
            </div>
          </div>
        </header>

        <section style={{ paddingTop: 24, paddingBottom: 48 }}>
          <ContentWrapper>
            <List list={list} noLinkTitle productClass={styles.product} />
          </ContentWrapper>
        </section>
      </section>
    </ScrollToTop>
  );
};

export default ExpertPage;
